import { create } from 'zustand';

const normalizeRoute = (route = '') => route
    .split('?')[0]
    // Edit pages include the record ID (for example, /scheme/scheme-definition/edit/1084).
    // Permissions are stored against the parent menu route, so remove the action and its ID.
    .replace(/\/(add|edit)(?:\/[^/]+)?\/?$/i, '')
    .replace(/\/+$/, '')
    .toLowerCase();

const createPermissionsByRoute = (menuList = []) => {
    const permissionsByRoute = {};

    const collectMenuPermissions = (menus = []) => {
        menus.forEach((menu) => {
            if (menu.route) {
                permissionsByRoute[normalizeRoute(menu.route)] = {
                    add: Boolean(menu.add),
                    update: Boolean(menu.update),
                    delete: Boolean(menu.delete),
                };
            }
            collectMenuPermissions(menu.children);
        });
    };

    collectMenuPermissions(menuList);
    return permissionsByRoute;
};

export const getMenuPermissionsForPath = (permissionsByRoute, pathname = window.location.pathname) => (
    permissionsByRoute[normalizeRoute(pathname)]
);

export const useMenuAccessStore = create((set) => ({
    permissionsByRoute: {},
    isMenuPermissionsLoaded: false,
    setUserMenuPermissions: (menuList) => set({
        permissionsByRoute: createPermissionsByRoute(menuList),
        isMenuPermissionsLoaded: true,
    }),
}));
